(() => {
  const PLAY_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5v15l13-7.5z"/></svg>';

  // Verwijdert losse play-knoppen uit de paginatekst (die werkten niet meer nadat de video verplaatst werd)
  function removeStrayPlayButtons(scope) {
    scope.querySelectorAll('[class*="play" i], [aria-label*="afspelen" i], [aria-label*="play" i], [onclick*="play" i]').forEach((el) => {
      if (el.closest('.esfari-process-media')) return;
      if (el.querySelector('video, iframe, img')) return;
      if (el.textContent.trim().length <= 3) el.remove();
    });
  }

  // Zet één werkende play-knop midden op elke video
  function addPlayButton(video) {
    if (video.closest('.esfari-process-video')) return;
    const box = document.createElement('div');
    box.className = 'esfari-process-video';
    video.parentNode.insertBefore(box, video);
    box.append(video);
    video.setAttribute('playsinline', '');
    video.removeAttribute('autoplay');
    video.controls = false;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'esfari-process-play';
    btn.setAttribute('aria-label', 'Video afspelen');
    btn.innerHTML = PLAY_ICON;
    box.append(btn);

    btn.addEventListener('click', () => { video.play(); });
    video.addEventListener('play', () => { box.classList.add('is-playing'); video.controls = true; });
    video.addEventListener('pause', () => { box.classList.remove('is-playing'); });
    video.addEventListener('ended', () => { box.classList.remove('is-playing'); });
  }

  function layout(root = document) {
    root.querySelectorAll('[data-esfari-page-content]').forEach((content) => {
      const identity = `${content.dataset.pageHandle} ${content.dataset.pageTitle}`.toLowerCase();
      if (!/graveer[\s-]*proces/.test(identity)) return;
      if (content.querySelector('.esfari-process-layout')) return;
      const videos = Array.from(content.querySelectorAll('video, iframe[src*="youtube"], iframe[src*="youtu.be"], iframe[src*="vimeo"], deferred-media'));
      const media = videos.filter((node) => !videos.some((other) => other !== node && other.contains(node)));
      if (!media.length) return;
      const frame = document.createElement('div');
      frame.className = 'esfari-process-layout';
      const copy = document.createElement('div');
      const panel = document.createElement('div');
      panel.className = 'esfari-process-media';
      media.forEach((node) => {
        let wrapper = node;
        while (wrapper.parentElement !== content && wrapper.parentElement && !wrapper.parentElement.textContent.trim() && wrapper.parentElement.querySelectorAll('video, iframe, deferred-media').length === node.querySelectorAll('video, iframe, deferred-media').length + 1) wrapper = wrapper.parentElement;
        panel.append(wrapper);
      });
      while (content.firstChild) copy.append(content.firstChild);
      frame.append(copy, panel);
      content.append(frame);
      removeStrayPlayButtons(copy);
      panel.querySelectorAll('video').forEach(addPlayButton);
    });
  }
  document.addEventListener('DOMContentLoaded', () => layout());
  document.addEventListener('shopify:section:load', (event) => layout(event.target));
})();
